import i18n from '@/i18n';
/** 万能改图参考图限制（与后端 Img2ImgImageResolver / Sanitizer 一致） */
import {
  IPE_UPLOAD_UNSUPPORTED_MESSAGE,
  validateIpeUploadFile,
} from '@/utils/ipeImageUploadFormats';
import { MAX_UPLOAD_FILES_PER_SESSION } from '@/utils/uploadSessionLimits';
import { UPLOAD_MAX_BYTES } from '@/utils/uploadConfig';

export const IMG2IMG_MAX_REFERENCES = MAX_UPLOAD_FILES_PER_SESSION;
export const IMG2IMG_MAX_EDGE_PX = 4096;
export const IMG2IMG_MAX_BYTES = UPLOAD_MAX_BYTES;

/**
 * 校验本地文件（格式、大小）；尺寸在 loadImageDimensions 后校验。
 */
export function validateImg2ImgFile(file) {
  const formatError = validateIpeUploadFile(file);
  if (formatError) {
    return formatError;
  }
  if (!file || !file.type) {
    return IPE_UPLOAD_UNSUPPORTED_MESSAGE;
  }
  if (file.size > IMG2IMG_MAX_BYTES) {
    return i18n.t('workbench:ipeUtilError.imageOver10mbTarget');
  }
  return null;
}

export function loadImageDimensions(src) {
  return new Promise((resolve) => {
    if (!src) {
      resolve(null);
      return;
    }
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.naturalWidth || 0,
        height: img.naturalHeight || 0,
      });
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

/**
 * 从本地 File/Blob 读尺寸，不走 /api/storage/images/view，避免大批量上传时 429 导致「无法读取图片尺寸」。
 */
export function loadImageDimensionsFromFile(file) {
  return new Promise((resolve) => {
    if (!(file instanceof Blob)) {
      resolve(null);
      return;
    }
    let objectUrl = '';
    try {
      objectUrl = URL.createObjectURL(file);
    } catch {
      resolve(null);
      return;
    }
    const img = new Image();
    img.onload = () => {
      const result = {
        width: img.naturalWidth || 0,
        height: img.naturalHeight || 0,
      };
      try {
        URL.revokeObjectURL(objectUrl);
      } catch {
        /* ignore */
      }
      resolve(result);
    };
    img.onerror = () => {
      try {
        URL.revokeObjectURL(objectUrl);
      } catch {
        /* ignore */
      }
      resolve(null);
    };
    img.src = objectUrl;
  });
}

export function validateImg2ImgDimensions(width, height) {
  if (!width || !height) {
    return i18n.t('workbench:ipeUtilError.cannotReadImageSize');
  }
  if (width > IMG2IMG_MAX_EDGE_PX || height > IMG2IMG_MAX_EDGE_PX) {
    return i18n.t('workbench:ipeUtilError.imageSizeOverMax', { max: IMG2IMG_MAX_EDGE_PX, width, height });
  }
  return null;
}
